<script context="module" lang="ts">
    import { writable } from "svelte/store";
    import { interaction, availableTools } from "$lib/state";

    export const activeTool = writable(-1);

    interaction.subscribe(int => {
        if (!int) return;
        int.onToolChanged.subscribe(tool => activeTool.set(tool));
        activeTool.set(int.tool);
    });
</script>

<script lang="ts">
    import { COMMANDS } from "$lib/commands";
    import { type Command, CommandButton, Shortcut } from "ceyper-common";
    import Icon from "$lib/utility/Icon.svelte";

    function getCommand(id: string) {
        return COMMANDS.commands[`editor.tool.${id}` as unknown as "editor.tool.pencil"] as Command;
    }
</script>

<!----------------------------------------------------------------------------->

<div class="padding"/>

{#each $availableTools as tool}
    {@const { id, index } = tool}
    {@const command = getCommand(id)}
    <!--{@const tool = type === "tool" ? $tool[id] : $tool[$activeGroups[id]]}-->
    <!--{@const ids = type === "tool" ? [id] : groups[id]}-->
    {@const active = index === $activeTool}

    <CommandButton {command} let:enabled let:invoke>
        <button
            class="tool"
            class:active={active}
            disabled={!enabled}
            on:click={() => invoke()}
        >
            <Icon id={tool.icon} />

            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <div class="info" on:click|stopPropagation>
                <h3>
                    <span>{tool.name}</span>
                    <Shortcut {command} />
                </h3>
                <p>
                    {tool.description}
                </p>

                <!--{#if type === "group"}-->
                <!--    <h4>Variants</h4>-->

                <!--    {#each ids as id}-->
                <!--        {@const subCommand = getCommand(id)}-->
                <!--        {@const subTool = $tool[id]}-->
                <!--        {@const active = $primary?.id === id}-->

                <!--        <CommandButton command={subCommand} let:enabled let:invoke>-->
                <!--            <button-->
                <!--                class="subtool"-->
                <!--                class:active-->
                <!--                disabled={!enabled || active}-->
                <!--                on:click={() => invoke()}-->
                <!--            >-->
                <!--                <Icon id={subTool.icon} size={1.5} />-->
                <!--                <span class="name">{subTool.name}</span>-->
                <!--                <Shortcut command={subCommand} />-->
                <!--            </button>-->
                <!--        </CommandButton>-->
                <!--    {/each}-->
                <!--{/if}-->
            </div>
        </button>
    </CommandButton>
{/each}

<!----------------------------------------------------------------------------->

<style>
    .padding {
        height: 2em;
        border-bottom: 2px solid var(--g50);
        margin-right: -2px;
        background: var(--panel-bg);
        /* prevent dynamic resizing */
        width: calc(3rem + 2px);
    }

    .tool {
        all: unset;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid var(--g50);
        font-size: 2rem;
        padding: 0.25em;

        position: relative;
    }

    .active > :global(.icon) {
        color: var(--gacc200);
    }

    .tool:hover > :global(.icon) {
        color: var(--tacc);
    }

    .info {
        position: absolute;
        pointer-events: none;

        display: flex;
        flex-direction: column;
        gap: 0.5em;

        top: 0;
        left: calc(100% + 0.5em);
        padding: 0.5em;
        width: 10em;

        background-color: var(--g100);
        outline: 1px solid var(--g50);

        font-size: 1rem;
        z-index: 100;

        visibility: collapse;

        transition-delay: 0s;
        transition-property: visibility;
    }

    .info::before {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        right: 100%;
        background: transparent;
        width: 0.5em;
    }

    button:hover .info {
        visibility: visible;
        pointer-events: all;
        transition-delay: 0.5s;
    }

    .info h3 {
        font-size: 1em;
        margin: 0;
        display: grid;
        grid-template-columns: 1fr max-content;
    }

    .info p {
        margin: 0;
    }

    .name {
        margin-right: 0.5em;
    }

    h4 {
        margin: 0;
        font-weight: normal;
        color: var(--t400);
    }

    .subtool {
        display: flex;
        width: 100%;
        color: var(--t100);
        align-items: center;
        gap: 0.5em;
    }
</style>
